import {
  GET_INBOX_SETUP,
  GET_INBOX_SETUP_FAILED,
  GET_INBOX_SETUP_SUCCESS,
  GET_LIST_SCREEN_SETUP,
  GET_LIST_SCREEN_SETUP_FAILED,
  GET_LIST_SCREEN_SETUP_SUCCESS,
  UPDATE_INBOX_SETUP,
  UPDATE_INBOX_SETUP_FAILED,
  UPDATE_INBOX_SETUP_SUCCESS,
  UPDATE_LIST_SCREEN_SETUP,
  UPDATE_LIST_SCREEN_SETUP_FAILED,
} from "./actionTypes"

const INITIAL_STATE = {
  listScreenSetup: null,
  loading: false,
  error: "",
  inboxSetup: null,
}

const ListScreen = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_LIST_SCREEN_SETUP:
    case GET_INBOX_SETUP:
    case UPDATE_INBOX_SETUP:
    case UPDATE_LIST_SCREEN_SETUP:
      return {
        ...state,
        loading: true,
      }
    case GET_LIST_SCREEN_SETUP_SUCCESS:
      return {
        ...state,
        listScreenSetup: action.payload,
        loading: false,
      }
    case GET_LIST_SCREEN_SETUP_FAILED:
    case GET_INBOX_SETUP_FAILED:
    case UPDATE_INBOX_SETUP_FAILED:
    case UPDATE_LIST_SCREEN_SETUP_FAILED:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
    case GET_INBOX_SETUP_SUCCESS:
    case UPDATE_INBOX_SETUP_SUCCESS:
      return {
        ...state,
        inboxSetup: action.payload,
        loading: false,
      }
    default:
      return state
  }
}
export default ListScreen
